// EBank Game entry point - consolidated bundle for ebank.nz
// Ensure userData is always defined as an object
window.userData = window.userData || {};

// Core dependencies (order matters for legacy code)
import './safe-bootstrap.js';

// jQuery, Bootstrap, Bloodhound and Typeahead are now loaded via script tags in the template
// to avoid bundling issues with immediate execution

// Views and shared utilities
import './views/views.js';
import './cookie-utils.js';
import './shared.js';
import './material.min.js';

// Game-specific code
import './chat-image-to-video.js';
import './ebankgame.js';

// Authentication and session management
import './auth-modal.js';
import './drawer-toggle.js';
import './session-manager.js';
import './embedded-checkout.js';

// Additional utilities from ebank-entry
import 'shepherd.js';
import './api-helper.js';
import './data-accessor.js';
import './autocomplete.js';
import './moderation.js';
import './file-upload.js';
import './signup.js';
import './string-utils.js';
import './dom-utils.js';
import './image-utils.js';
import './navigation-utils.js';
import './collection-utils.js';
import './template-utils.js';
import './auth-utils.js';
import './background-utils.js';
import './emoji-modal-optimized.js';
window.__netwrckEbankGameBundleReady = true;
